<div *ngIf="viewHTML" [innerHTML]="viewHTML" style="width: 100%"></div>
